import React from "react";
import { Flex, Text, Button, Tag } from "@appsmith/ads";
import styled from "styled-components";

interface ToolHeaderProps {
  name: string;
  icon?: React.ReactNode;
  isCollapsed?: boolean;
  onClick: () => void;
  selectedCount: number;
}

const StyledTag = styled(Tag)`
  border: 1px solid var(--ads-v2-color-border);
`;

export const ToolHeader = (props: ToolHeaderProps) => {
  const { icon, isCollapsed, name, onClick, selectedCount } = props;

  return (
    <Flex
      alignItems="center"
      borderBottom={
        isCollapsed ? "none" : "1px solid var(--ads-v2-color-border)"
      }
      justifyContent="space-between"
      onClick={onClick}
      padding="spaces-4"
    >
      <Flex alignItems="center" gap="spaces-3">
        <Flex alignItems="center" gap="spaces-2">
          {icon}
          <Text kind="heading-xs">{name}</Text>
        </Flex>
        <StyledTag isClosable={false}>{selectedCount}</StyledTag>
      </Flex>
      <Button
        isIconButton
        kind="tertiary"
        size="sm"
        startIcon={isCollapsed ? "arrow-down-s-line" : "arrow-up-s-line"}
      />
    </Flex>
  );
};
